import { HIDE_MODAL,SHOW_MODAL } from "./constants";

const modal = {};

modal.open = (type, props = {}) => ({
  type: SHOW_MODAL,
  modalType: type,
  modalProps: {
    ...props,
    open: true
  }
});

modal.close = () => ({
  type: HIDE_MODAL
});

export default modal;
